export const CHANGE_NEW_PROJECT = 'CHANGE_NEW_PROJECT';
export const CHANGE_OLD_PROJECT = 'CHANGE_OLD_PROJECT';
export const CHANGE_UKR_LANGUAGE = 'CHANGE_UKR_LANGUAGE';
export const CHANGE_ENG_LANGUAGE = 'CHANGE_ENG_LANGUAGE';
export const SET_LANGUAGE = 'SET_LANGUAGE';
